document.addEventListener('DOMContentLoaded', ()=> {
    const body = document.querySelector('body') || null;
    if(body === null) return;
    const bodyClassList = body.classList;
    if(bodyClassList.contains('template-product')){
        const galleries = body.querySelectorAll('media-gallery');
        galleries.forEach((gallery) => {
            const deferredMedia = gallery.querySelector('deferred-media');

            if (deferredMedia) {
                const poster = deferredMedia.querySelector('.deferred-media__poster');
                poster.style.setProperty('display', 'none');
                const template = deferredMedia.querySelector('template');

                if (template) {
                    const content = template.content.cloneNode(true);
                    deferredMedia.appendChild(content);

                    const video = deferredMedia.querySelector('video');

                    if (video) {
                        video.muted = true; // Required for autoplay in most browsers
                        video.play().catch(err => {
                            console.log('Autoplay blocked:', err);
                        });
                    }
                }
            }
        });
    }else{
        console.clear();
        console.log("Body te class pawa jay nai...");
    }
});